import * as React from 'react'
export const EmailIcon = () => {
  return (
    <svg width='23' height='19' viewBox='0 0 23 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22.0605 2.79199L10.8955 9.2373L0.00878915 2.9502C0.114258 1.30371 1.48242 0 3.15527 0H18.9258C20.5459 0 21.8818 1.21875 22.0605 2.79199ZM22.0811 5.10059V14.9121C22.0811 16.6553 20.6689 18.0674 18.9258 18.0674H3.15527C1.41211 18.0674 0 16.6553 0 14.9121V5.26758L10.3975 11.2705C10.7549 11.4756 11.1855 11.4375 11.4961 11.209C11.5107 11.2031 11.5225 11.1943 11.5371 11.1855L22.0811 5.10059Z'
        fill='current'
      />
    </svg>
  )
}

export const EmailIcon2 = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='stroke'
    >
      <g clipPath='url(#clip0_1765_1990)'>
        <path
          d='M18.3307 5.83594L10.8382 10.6084C10.584 10.7561 10.2952 10.8339 10.0011 10.8339C9.70712 10.8339 9.41832 10.7561 9.16406 10.6084L1.66406 5.83594'
          stroke='current'
          strokeWidth='1.66667'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.6641 3.33594H3.33073C2.41025 3.33594 1.66406 4.08213 1.66406 5.0026V15.0026C1.66406 15.9231 2.41025 16.6693 3.33073 16.6693H16.6641C17.5845 16.6693 18.3307 15.9231 18.3307 15.0026V5.0026C18.3307 4.08213 17.5845 3.33594 16.6641 3.33594Z'
          stroke='current'
          strokeWidth='1.66667'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1765_1990'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
